<div class="header mt-md-5">
  <div class="header-body">
    <div class="row align-items-center">
      <div class="col">

        <!-- Pretitle -->
        <h6 class="header-pretitle">
          Aperçu
        </h6>

        <!-- Title -->
        <h1 class="header-title">
          {{ this.organizationName }}
        </h1>

      </div>
    </div> <!-- / .row -->
    <div class="row align-items-center">
      <div class="col">

        <!-- Nav -->
        <ul class="nav nav-tabs nav-overflow header-tabs">
          <li class="nav-item">
            <a [class.active]="this.menuService.menuItems['/organization/settings'].isActive" class="nav-link"
               routerLink="/organization/settings">
              Paramètres
            </a>
          </li>
          <li class="nav-item">
            <a [class.active]="this.menuService.menuItems['/organization/employees'].isActive" class="nav-link"
               routerLink="/organization/employees">
              Employés
            </a>
          </li>
          <li class="nav-item">
            <a [class.active]="this.menuService.menuItems['/organization/billing'].isActive" class="nav-link"
               routerLink="/organization/billing">
              Paiement et Facturation
            </a>
          </li>
        </ul>

      </div>
    </div>
  </div>
</div>